import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IcosInputNumber } from './input-number'


@NgModule({
  declarations: [IcosInputNumber],
  exports: [IcosInputNumber],
  imports: [CommonModule, FormsModule],
  entryComponents: [IcosInputNumber],
})
export class IcosInputNumberModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosInputNumberModule, providers: [] }
  }
}
